// extracted by mini-css-extract-plugin
export default {"page-row":"SRP__page-row___fsXvX"};